import type {MutationUpdaterFunction, DefaultContext} from '@apollo/client';

import type {
  UnregisterDeviceMutation,
  UnregisterDeviceMutationVariables,
} from '../../types/graphql';
import type {NudgeCache} from '../init';

/**
 * Update the cache after unregistering a device.
 */
export const updateOnUnregisterDevice: MutationUpdaterFunction<
  UnregisterDeviceMutation,
  UnregisterDeviceMutationVariables,
  DefaultContext,
  NudgeCache
> = (cache, {errors}, {variables}) => {
  if (errors?.length) {
    return;
  }

  if (!variables?.deviceId) {
    return;
  }

  // Remove the device from the cache.
  cache.evict({
    id: cache.identify({__typename: 'Device', id: variables.deviceId}),
  });
};
